export default __webpack_public_path__ + "static/media/949.ff7cd028.jpg";